<div class="row">
  @if (displayAnnees === undefined || displayAnnees) {
    <div class="col width-miniCol">
      <mat-form-field>
        <mat-label>{{'general.annee' | translate}}s</mat-label>
        <mat-select id="filters-dossier-annees" multiple
          [(ngModel)]="anneesSelected"
          (ngModelChange)="anneesSelectedChanged()">
          @for (annee of annees; track annee) {
            <mat-option [value]="annee">
              {{annee}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (displayInstance === undefined || displayInstance === true) {
    <div class="col width-column">
      <mat-form-field>
        <mat-label>{{ 'general.listCommissions' |translate }}
        </mat-label>
        <mat-select id="filters-dossier-commission"
          [(ngModel)]="commissionSelected"
          (ngModelChange)="commissionSelectedChanged()"
          [disabled]="anneesSelected.length === 0"
          panelClass="with-ellipsis"
          >
          <mat-option [value]="null">--{{ 'general.nonSpecifie' | translate}}--</mat-option>
          @for (commission of commissionsFiltered; track commission) {
            <mat-option [value]="commission">
              {{ commission.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (displayReunion === undefined || displayReunion === true) {
    <div class="col width-column">
      <mat-form-field>
        <mat-label>{{ 'general.reunion' | translate }} </mat-label>
        <mat-select id="filters-dossier-commissionSeance"
          [(ngModel)]="commissionSeanceSelected"
          (ngModelChange)="commissionSeanceSelectedChanged()"
          [disabled]="anneesSelected.length === 0"
          panelClass="full-option-size"
          >
          <mat-option [value]="null">--{{ 'general.nonSpecifie' | translate}}--</mat-option>
          @for (commissionSeance of commissionSeancesFiltered; track commissionSeance) {
            <mat-option [value]="commissionSeance">
              {{ commissionSeance.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  <div class="col width-miniCol">
    <mat-form-field>
      <mat-label for="filters-dossier-aideSousType">{{ 'general.sousTypeAide' | translate }} </mat-label>
      <mat-select id="filters-dossier-aideSousType"
        [(ngModel)]="aideSousTypesSelected"
        (ngModelChange)="aideSousTypesSelectedChanged()"
        multiple
        panelClass="full-option-size filter-with-button"
        >
        <button mat-flat-button color="warn" class="button-reset-filter mat-elevation-z3" [disabled]="!aideSousTypesSelected.length" (click)="resetSousType()">{{'general.decocher' | translate}} ({{aideSousTypesSelected.length}})</button>
        @for (aideTypeGroup of aideSousTypesFiltered | keyvalue; track aideTypeGroup) {
          @if (aideTypeGroup.value?.aideSousTypes?.length) {
            <mat-optgroup
              [label]="aideTypeGroup.value.aideType.label"
              >
              @for (aideSousType of aideTypeGroup.value.aideSousTypes; track aideSousType) {
                <mat-option
                  [value]="aideSousType" [ngStyle]="{ display : aideSousType.enabled ? '' : 'none'}">
                  {{aideSousType.code}} - {{aideSousType.label}}
                </mat-option>
              }
            </mat-optgroup>
          }
        }
      </mat-select>
    </mat-form-field>
  </div>
  @if (multipleAides) {
    <div class="col width-aap">
      <mat-form-field>
        <mat-label for="filters-dossier-aide-multiple">{{ 'general.aide' | translate}} </mat-label>
        <mat-select id="filters-dossier-aide-multiple"
          [(ngModel)]="aideSelected"
          (ngModelChange)="aideSelectedChanged()"
          [disabled]="isAideFilterDisabled()"
          multiple
          panelClass="full-option-size"
          >
          <button mat-flat-button color="warn" class="button-reset-filter mat-elevation-z3" [disabled]="!aideSelected.length" (click)="resetAAP()">{{'general.decocher' | translate}} ({{aideSelected.length}})</button>
          @for (aide of aidesFiltered; track aide) {
            <mat-option [value]="aide">
              {{aide.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (!multipleAides) {
    <div class="col width-aap">
      <mat-form-field>
        <mat-label for="filters-dossier-aide">{{ 'general.aide' | translate}} </mat-label>
        <mat-select id="filters-dossier-aide"
          [(ngModel)]="aideSelected[0]"
          (ngModelChange)="aideSelectedChanged()"
          [disabled]="(!this.commissionSeanceSelected && this.anneesSelected.length === 0)"
          panelClass="full-option-size"
          >
          <mat-option [value]="null">--{{ 'general.nonSpecifie' | translate}}--</mat-option>
          @for (aide of aidesFiltered; track aide) {
            <mat-option [value]="aide">
              {{aide.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  <div class="col width-reset">
    <button mat-raised-button (click)="resetFilters()" [matTooltip]="messageReinitFiltre"><mat-icon>restart_alt</mat-icon></button>
  </div>
</div>

